import PrivateKeyIcon from './PrivateKeyIcon'

export default PrivateKeyIcon
